import React, { useEffect, useState } from "react";
import { project } from "../../../system/types/project/project";
import { ProjectApi } from "../../../system/api/ProjectApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { useNavigate } from "react-router-dom";

import "./ListProjects.scss";

const ListProjects = () => {
    const navigate = useNavigate();

    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');

    const [projectList, setProjectList] = useState<project[]>([]);


    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }
    });

    const loadList = async () => {
        const api = new ProjectApi(sessionToken, sessionEmail);
        const result = await api.getListProjects();
        setProjectList(result);
    }

    const gotToProject = (id: string) => {
        navigate('/projects/' + id );
    }

    useEffect(() => {
        if (sessionEmail === '') {
            return;
        }
        loadList();
    }, [sessionEmail]);


    return (<div className="listProjects mt-3">
    {projectList.map((project) => (
        <div className="row mb-3" key={project._id}>
            <div className="col-auto">
                <span className="link" onClick={() => {
                    gotToProject(project._id);
                }}><strong>{project.name}</strong> - {project.baseLanguage.name}</span><br />
                {project.description}
            </div>
        </div>
    ))}
    </div>);
};

export { ListProjects };
